import {
  INFO_BACKGROUND,
  INFO_COLOR,
  WARNING_BACKGROUND,
  WARNING_COLOR
} from "../../../../../../../../../themes/themeConfigurator";

const styles = theme => ({
  stepInfoText: {
    fontSize: 16,
    fontFamily: 'Roboto-Bold',
    marginBottom: 16,

    '&.newDesign': {
      '--card-color': INFO_COLOR,
      '--card-bg-color': INFO_BACKGROUND,

      '&.warning': {
        '--card-color': WARNING_COLOR,
        '--card-bg-color': WARNING_BACKGROUND,
      },

      display: 'flex',
      fontFamily: 'Roboto-Regular',
      background: 'var(--card-bg-color)',
      border: '1px solid #B5BBC2',
      borderLeft: `6px solid var(--card-color)`,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(4),
      marginBottom: 0,

      '& .fa-icon': {
        fontSize: '1.3em',
        color: 'var(--card-color)',
        paddingRight: theme.spacing(1),
        paddingTop: 4,
      }
    }
  },
});

export default styles;